import FormWrapper from './form-wrapper.vue';

export default FormWrapper;
